export default __webpack_public_path__ + "static/media/rose-pic.2230a755.jpg";